import { warning, isSwalVisible } from "@alert";

export const PAGE_LEAVE_CONFIRM_TITLE = "確定離開？";
export const PAGE_LEAVE_CONFIRM_MESSAGE = "尚未儲存的變更將遺失";

let guardRef = null;

export function registerPageLeaveGuard(guard) {
  guardRef = guard;
}

export function unregisterPageLeaveGuard() {
  guardRef = null;
}

export function isPageLeaveDirty() {
  return Boolean(guardRef?.isDirty?.());
}

export function discardPageLeaveChanges() {
  guardRef?.discard?.();
}

/**
 * 有未儲存變更時先確認再執行 onLeave；無變更則直接執行。
 * 注意：不可在「無變更」時因其他 Swal 顯示而吞掉 onLeave（會弄壞換分店／導覽）。
 */
export function confirmPageLeaveIfDirty(onLeave, options = {}) {
  const {
    title = guardRef?.title || PAGE_LEAVE_CONFIRM_TITLE,
    message = guardRef?.message || PAGE_LEAVE_CONFIRM_MESSAGE,
    confirmText = guardRef?.confirmText || "離開",
    cancelText = guardRef?.cancelText || "取消",
  } = options;

  if (!isPageLeaveDirty()) {
    onLeave?.();
    return;
  }

  // 已有確認框時勿疊加；但不要在非 dirty 路徑使用此早退
  if (isSwalVisible()) return;

  warning(2, title, message, confirmText, cancelText, () => {
    discardPageLeaveChanges();
    onLeave?.();
  });
}
